import { render, staticRenderFns } from "./MeshFrameDialog.vue?vue&type=template&id=07c4f2cd"
import script from "./MeshFrameDialog.vue?vue&type=script&lang=js"
export * from "./MeshFrameDialog.vue?vue&type=script&lang=js"
import style0 from "./MeshFrameDialog.vue?vue&type=style&index=0&id=07c4f2cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports